import { Injectable } from '@angular/core';
import { ApiService } from './api';

import { Membership } from '../model/membership';
import { Organization } from '../model/organization';
import { Account } from 'model/account';

@Injectable()
export class OrganizationService {
    constructor(private api: ApiService) { }

    getOrganizations() : Promise<Organization[]> {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.organizations + '/getall')
                .then(data => resolve(data as Organization[]), error => reject(error));
        });
    }

    getOrganization(organizationId: number) : Promise<Organization> {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.organizations + '/get?organizationId=' + organizationId)
                .then(data => resolve(data as Organization), error => reject(error));
        });
    }

    addMembership(membership: Membership) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.organizations + '/addMembership', membership)
                .then(data => resolve(data), error => reject(error));
        });
    }

    createOrganization(organization: Organization) : Promise<Organization> {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.organizations + '/createOrganization', organization)
                .then(data => resolve(data as Organization), error => reject(error));
        });
    }

    getAllStaffAccounts(organizationId: number) : Promise<Account[]> {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.organizations + '/getAllStaffMembers?organizationId=' + organizationId)
                .then(data => resolve(data as Account[]), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/organization.service.ts